/* ioga — interacciones: nav, fade-up, carrusel dots, acordeón footer, drawer, video */
(function () {
  "use strict";

  /* --- nav: transparente sobre hero -> sólida al scroll > 80px;
         además compensa la barra de anuncio mientras está visible --- */
  var nav = document.querySelector(".nav");
  var announce = document.querySelector(".announce");

  function onScroll() {
    var y = window.scrollY;
    nav.classList.toggle("is-solid", y > 80);
    if (announce) {
      var h = announce.offsetHeight;
      var rest = Math.max(h - y, 0);
      nav.style.transform = "translateY(" + rest + "px)";
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  onScroll();

  /* --- fade-up al entrar (una vez) --- */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("is-in");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    document.querySelectorAll(".fade-up").forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll(".fade-up").forEach(function (el) { el.classList.add("is-in"); });
  }

  /* --- carruseles con dots (scroll-snap) --- */
  document.querySelectorAll("[data-carousel]").forEach(function (rail) {
    var dotsWrap = document.querySelector('[data-dots="' + rail.dataset.carousel + '"]');
    if (!dotsWrap) return;
    var cards = rail.children;
    var dots = [];
    for (var i = 0; i < cards.length; i++) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", "Ir a la tarjeta " + (i + 1));
      (function (idx) {
        b.addEventListener("click", function () {
          var card = cards[idx];
          rail.scrollTo({ left: card.offsetLeft - rail.offsetLeft, behavior: "smooth" });
        });
      })(i);
      dotsWrap.appendChild(b);
      dots.push(b);
    }
    function update() {
      var x = rail.scrollLeft;
      var best = 0, bestD = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs((cards[i].offsetLeft - rail.offsetLeft) - x);
        if (d < bestD) { bestD = d; best = i; }
      }
      dots.forEach(function (dot, i) { dot.classList.toggle("is-active", i === best); });
    }
    rail.addEventListener("scroll", update, { passive: true });
    update();
  });

  /* --- acordeón footer (solo activo en mobile via CSS) --- */
  document.querySelectorAll(".footer-col .acc-toggle").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var col = btn.closest(".footer-col");
      var open = col.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  /* --- drawer mobile --- */
  var drawer = document.getElementById("drawer");
  var burger = document.querySelector(".nav-burger");
  function setDrawer(open) {
    drawer.classList.toggle("is-open", open);
    burger.setAttribute("aria-expanded", open ? "true" : "false");
    document.body.style.overflow = open ? "hidden" : "";
  }
  burger.addEventListener("click", function () { setDrawer(true); });
  drawer.querySelector(".drawer-scrim").addEventListener("click", function () { setDrawer(false); });
  drawer.querySelector(".drawer-close").addEventListener("click", function () { setDrawer(false); });
  drawer.querySelectorAll("nav a").forEach(function (a) {
    a.addEventListener("click", function () { setDrawer(false); });
  });

  /* --- video modal (guard: no existe en páginas de blog/about) --- */
  var modal = document.getElementById("video-modal");
  function setModal(open) {
    if (!modal) return;
    modal.classList.toggle("is-open", open);
    document.body.style.overflow = open ? "hidden" : "";
  }
  if (modal) {
    document.querySelectorAll("[data-open-video]").forEach(function (el) {
      el.addEventListener("click", function (ev) {
        ev.preventDefault();
        setModal(true);
      });
    });
    modal.querySelector(".vm-close").addEventListener("click", function () { setModal(false); });
    modal.addEventListener("click", function (e) { if (e.target === modal) setModal(false); });
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { setModal(false); setDrawer(false); }
  });
})();

/* safety net: revela cualquier .fade-up que el IntersectionObserver se haya perdido
   (scroll muy rápido, JS lento, o restauración de scroll) — evita bloques en blanco */
(function () {
  function rv() {
    document.querySelectorAll(".fade-up:not(.is-in)").forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.95) el.classList.add("is-in");
    });
  }
  window.addEventListener("scroll", rv, { passive: true });
  window.addEventListener("load", rv);
  setTimeout(rv, 500);
})();

/* --- autoplay robusto de TODOS los videos, incluido mobile (iOS/Android) ---
   muted+playsinline + play() explícito, reintento en canplay, y red de seguridad
   que reproduce cualquier video visible al hacer scroll o al primer toque. */
(function () {
  var vids = document.querySelectorAll("video");
  if (!vids.length) return;
  function prep(v) {
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    v.setAttribute("muted", ""); v.setAttribute("playsinline", ""); v.setAttribute("webkit-playsinline", "");
  }
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function nudge(v) {
    prep(v);
    if (v.readyState >= 2) { play(v); }
    else { v.addEventListener("canplay", function () { play(v); }, { once: true }); play(v); }
  }
  vids.forEach(prep);
  if ("IntersectionObserver" in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { nudge(e.target); }
        else { try { e.target.pause(); } catch (x) {} }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { vio.observe(v); });
  } else {
    vids.forEach(nudge);
  }
  function kick() {
    vids.forEach(function (v) {
      var r = v.getBoundingClientRect();
      if (v.paused && r.top < window.innerHeight && r.bottom > 0) nudge(v);
    });
  }
  window.addEventListener("touchstart", kick, { passive: true });
  window.addEventListener("scroll", kick, { passive: true });
  window.addEventListener("load", kick);
  document.addEventListener("visibilitychange", function () { if (!document.hidden) kick(); });
})();
